import { render, staticRenderFns } from "./userActivities.vue?vue&type=template&id=f699c682&scoped=true"
import script from "./userActivities.vue?vue&type=script&lang=js"
export * from "./userActivities.vue?vue&type=script&lang=js"
import style0 from "./userActivities.vue?vue&type=style&index=0&id=f699c682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f699c682",
  null
  
)

export default component.exports